/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowWithText = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowWithText = $.extend(this, window.PXUTheme.getSectionData($section));

    const textTransition = this.text_transition;

    // Selectors
    const $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
    const $textSlideshowEl = $section.find('[data-text-slideshow]').removeClass('is-hidden');

    const $imageSlideshow = $imageSlideshowEl.flickity({
      contain: true,
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          const prevArrow = $imageSlideshowEl.find('.flickity-prev-next-button.previous');
          const nextArrow = $imageSlideshowEl.find('.flickity-prev-next-button.next');

          prevArrow.html(`
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.765456 6.05385C-0.136261 6.36236 -0.13626 7.63765 0.765458 7.94616L16.9263 13.4753C17.5752 13.6973 18.25 13.215 18.25 12.5292L18.25 1.47083C18.25 0.78495 17.5752 0.30265 16.9263 0.524679L0.765456 6.05385Z" fill="black"/>
            </svg>
          `);

          nextArrow.html(`
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.2345 6.05385C19.1363 6.36236 19.1363 7.63765 18.2345 7.94616L2.07371 13.4753C1.42476 13.6973 0.749999 13.215 0.75 12.5292L0.750001 1.47083C0.750002 0.78495 1.42476 0.30265 2.07371 0.524679L18.2345 6.05385Z" fill="black"/>
            </svg>
          `);
          updateSliderLine(0);
        },
        change: function(index) {
          updateSliderLine(index);
        }
      }
    });

    const $textSlideshow = $textSlideshowEl.flickity({
      autoplay: false,
      contain: true,
      imagesLoaded: true,
      lazyload: 4,
      prevNextButtons: false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      on: {
        ready: function () {
          const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
          window.PXUTheme.animation.slideTransition($currentTextSlide, textTransition);
        }
      }
    });

    $imageSlideshow.on('change.flickity', function (event, index) {
      $textSlideshow.flickity('select', index, true, true);

      const $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
      window.PXUTheme.animation.slideTransition($currentTextSlide, textTransition);

    });

    $textSlideshow.on('change.flickity', function (event, index) {
      $imageSlideshow.flickity('select', index, true, false);
    });

    // $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');

    function updateSliderLine(index) {
      const totalSlides = 2;
      const widthPercentage = (index / (totalSlides - 1)) * 100 == 0 ? 50 : 100;

      $('.slider-indicator').css('width', `${widthPercentage}%`);
    }
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

    // Resize flickity when the slider is settled
    $slider.on( 'settle.flickity', function() {
      $slider.flickity('resize');
    }, 500);

  },
	unload: function($section) {
    $section.find('.flickity-button').unwrap();
	}
}

/******/ })()
;